module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"country":"Страна","noCountryFound":"Не найдено"}}')
  delete Component.options._Ctor
}
